<header
	class="top-nav-bar--{{
		matterFileType
	}} rounded-t-md flex justify-between items-center px-3 py-3 gap-3"
>
	<div class="flex items-center">
		<app-button
			class="mr-1"
			[icon]="ICON.PIN"
			[iconStyle]="(pinned$ | async) ? ICON_STYLE.SOLID : ICON_STYLE.REGULAR"
			btn="tertiary"
			[tooltip]="(pinned$ | async) ? 'Unpin' : 'Pin'"
			(onClick)="pin()"
			[testHook]="testHooks.PinButton"
		></app-button>
		<span class="font-semibold file-description mr-3">{{
			matterFileType | titlecase
		}}</span>
		<app-pill-dropdown-component
			class="w-full inline-flex capitalize"
			[dropdownOptionItems]="[{ items: pillDropdownOptions }]"
			[ngModel]="status"
			type="pill-dropdown"
			pillMode="{{ status + 'Status' }}"
			[checkmark]="status === matterStatus.CLOSED"
			size="small"
			(onSelect)="updateMatterStatus($event)"
			[testHook]="testHooks.StatusPillDropdownComponent"
		>
		</app-pill-dropdown-component>
	</div>

	<div
		class="flex cursor-pointer items-center gap-3 min-w-0 max-w-md xl:max-w-none"
		(click)="goToMatter()"
		[testHook]="testHooks.GoToMatterDiv"
	>
		<span
			size="small"
			class="matter-number truncate"
			[matTooltip]="number.length >= 25 ? number : null"
			>#{{ number }}</span
		>
		<h1
			class="heading--4 font-semibold mb-0 truncate"
			[matTooltip]="name.length >= 50 ? name : null"
		>
			{{ name }}
		</h1>
	</div>

	<div>
		<div class="flex gap-5 items-center">
			<app-matter-activity class="bg-white h-7 text-sm"></app-matter-activity>
			<app-checklist-nav-bar></app-checklist-nav-bar>
			<app-sale-to-nav-notes></app-sale-to-nav-notes>
			<app-documents-nav-bar
				*ngIf="useHtmlDocuments$ | async"
			></app-documents-nav-bar>
			<!-- FT: I don't think we need this but confirm. Afernee confirmed in code review and we don't need it. Remove in Cleanup PR. -->
			<ui-button
				*ngIf="loadedFromLeap"
				classes="bot-trigger--feedback"
				icon="headset"
				color="secondary"
				[testHook]="testHooks.Button"
			></ui-button>
		</div>
	</div>
</header>
